module.exports = THD_LOCALIZER_AUTO_INIT.thdEventEmitter;